if (!customElements.get('product-editorial-accordion')) {
  customElements.define(
    'product-editorial-accordion',
    class ProductEditorialAccordion extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.items.forEach((item) => {
          const trigger = item.querySelector('[data-accordion-trigger]');
          trigger?.addEventListener('click', () => this.toggleItem(item));
        });

        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize);
        this.items.forEach((item) => {
          const isOpen = item.classList.contains('is-open');
          this.setItemState(item, isOpen);
        });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
      }

      toggleItem(nextItem) {
        const willOpen = !nextItem.classList.contains('is-open');

        this.items.forEach((item) => this.setItemState(item, false));
        if (willOpen) this.setItemState(nextItem, true);
      }

      setItemState(item, isOpen) {
        const trigger = item.querySelector('[data-accordion-trigger]');
        const panel = item.querySelector('[data-accordion-panel]');
        if (!trigger || !panel) return;

        item.classList.toggle('is-open', isOpen);
        trigger.setAttribute('aria-expanded', String(isOpen));
        panel.style.maxHeight = isOpen ? `${panel.scrollHeight}px` : '0px';
        panel.style.opacity = isOpen ? '1' : '0';
      }

      handleResize() {
        this.items.forEach((item) => {
          if (item.classList.contains('is-open')) this.setItemState(item, true);
        });
      }
    }
  );
}
